module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"height (boxes)":"Height (boxes)","width (boxes)":"Width (boxes)","slide settings":"Slide settings","font":"Font","add font long":"Add a font by dropping it here.","add font short":"Add as font."}}')
  delete Component.options._Ctor
}
